import { BYSTADIUM_MARKETING_URL } from "@stadium/helpers/src/app-routes";

export const FAQ_URL =
  "https://help.bystadium.com/hc/en-us/sections/16053599939351-General-Questions";
export const TERMS_OF_USE_URL = "https://www.bystadium.com/terms-of-use/";
export const NEED_HELP_URL = "https://help.bystadium.com/hc/en-us";
export const SHOP_SNACKMAGIC_TRAYS = "https://shop.snackmagic.com/collections/trays";
export const TEAMS_WALLET_LEARN_MORE = "https://www.bystadium.com/wallet/";
export const REQUEST_INTEGRATION_LEARN_MORE = "https://www.bystadium.com/integrations/";
export const REQUEST_INTEGRATION_TYPEFORM = "https://by-stadium.typeform.com/to/RI3vNY2F";

export const COLLECTION_ADD_ADMIN_ROUTE_PATHNAME = "/collection/[collectionId]/add-admin";
export const LOCKER_COLLECTION_VIEW_ROUTE_PATHNAME = "/locker/collection/[collectionId]";

export const COLLECTION_ADD_ADMIN_ROUTE =
  process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME + COLLECTION_ADD_ADMIN_ROUTE_PATHNAME;
export const TEAM_WALLET_LEARN_MORE_LINK = `${BYSTADIUM_MARKETING_URL}/wallet`;
export const GO_BYSTADIUM_GET_A_QUOTE_ROUTE = "https://go.bystadium.com/welcome";

export const WAREHOUSE_FEE_FAQ_ROUTE =
  "https://help.bystadium.com/hc/en-us/articles/20932593972119-Fees-for-Storing-Swag-in-Your-Stadium-Locker";

export const POMP_TERM_OF_USE_URL =
  "https://help.bystadium.com/hc/en-us/articles/26684151366039-Peace-of-Mind-Protection-Overview";

export const GOOGLE_CHROME_EXTENSION =
  "https://chromewebstore.google.com/detail/stadium/boeobplnnbejgfdcmmbbdefimgekppbo";

export const STADIUM_INTEGRATIONS_FAQ =
  "https://help.bystadium.com/hc/en-us/articles/14707730987671-Stadium-Integrations-Overview";

export const ZAPIER_INTEGRATION_URL = "https://zapier.com/apps/stadium/integrations";
